import { Billing, BillingClient } from "../../system/Domain";

export default (billing? : Billing, client? : BillingClient) => (client
	? billing?.invoices.filter(i => i.client === client.name)
	: billing?.invoices) ?? [];
